import { ReactRenderer } from '@tiptap/react';

import tippy from 'tippy.js';

import { SuggestionsList } from './SuggestionsList.tsx';

export interface SuggestionsConfig {
  triggerChar: string;
  items: string[];
  endChars?: string[]; // end characters to ignore when determining if the input is a valid trigger (i.e. for mustache suggestions this would be ['}', '}}'])
  listTitle?: string;
  emptyStateMessage?: string;
}

export const Suggestions = ({
  suggestions,
}: {
  suggestions: SuggestionsConfig;
}) => ({
  char: suggestions.triggerChar,

  items: ({ query }) => {
    return suggestions.items.filter((item) =>
      item.toLowerCase().startsWith(query.toLowerCase())
    );
  },

  render: () => {
    let suggestionListComponent;
    let popup;

    return {
      onStart: (props) => {
        suggestionListComponent = new ReactRenderer(SuggestionsList, {
          props: {
            ...props,
            endChars: suggestions.endChars,
            listTitle: suggestions.listTitle,
            emptyStateMessage: suggestions.emptyStateMessage,
          },
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: suggestionListComponent.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
        });
      },

      onUpdate(props) {
        suggestionListComponent.updateProps(props);

        if (!props.clientRect) {
          return;
        }

        popup[0].setProps({
          getReferenceClientRect: props.clientRect,
        });
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup[0].hide();

          return true;
        }

        return suggestionListComponent.ref?.onKeyDown(props);
      },

      onExit() {
        popup[0].destroy();
        suggestionListComponent.destroy();
      },
    };
  },
});
